import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ButtonFlat } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const UserMessageOuter = styled(Flex)`
    box-sizing: border-box;
    width: 100%;
    flex-direction: column;
    align-items: flex-end;

    padding-left: 60px;
`;

export const UserBubble = styled(Flex)`
    box-sizing: border-box;
    max-width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    border-radius: 24px;
    background-color: ${colorsPalettes.bluegrey[200]};
    padding: 8px 12px;
`;

export const UserBubbleText = styled.p<{ $clamped: boolean }>`
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    ${setFontVariant("body1", colorsPalettes.carbon[500])};
    line-height: 24px;

    ${({ $clamped }) =>
        $clamped &&
        css`
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
        `}
`;

export const ExpandToggleButton = styled(ButtonFlat)`
    align-self: flex-end;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    padding: 4px 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: center;
    border-radius: 16px;
    font-feature-settings:
        "liga" 0,
        "clig" 0;
    ${setFontVariant("button", colorsPalettes.carbon[500])};

    &:hover {
        background: ${colorsPalettes.bluegrey[300]};
    }

    &:focus-visible {
        outline: 2px solid ${colorsPalettes.blue[400]};
        outline-offset: 2px;
    }
`;
